declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
import { DoctorsListController, DoctorAppointmentsByDoctorcodeContoller, DoctorAppointmentsByDoctorCodeRequest, AppointmentDetailsByAppointmentCodeRequest, AppointmentDetailsByAppointmentCodeController, SavePatientVisitRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { DoctorsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { DoctorListPipe, PatientListPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { windowTime } from 'rxjs/operators';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'visitregister',
  templateUrl: './visitregister.component.html',
  styleUrls: ['./visitregister.component.css']
})
export class VisitregisterComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public DoctorsList: boolean = true;
  public SelectedDoctor: boolean = false;
  public SelectedPatient: boolean = false;
  public Checkin: boolean = false;
  public Encstart: boolean = false;
  public Encend: boolean = false;
    public Checkout: boolean = false;
    public IsSelected: boolean=true;
  CurrentTime: any;
  ChekIn: NgbDateStruct;

  CurrentSavePatientVisitInformationRequest: SavePatientVisitRequest;
  CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcodeContoller[];
  CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCodeRequest;
  SelectedAppointmentDetailsByAppointmentCodeController: AppointmentDetailsByAppointmentCodeController[];
  SelectedAppointmentDetails: AppointmentDetailsByAppointmentCodeController;
  LoadDoctorAppointmentsByDoctor() {
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcodeContoller>();

    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCodeRequest();
    this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 10;
    //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorAppointmentsByDoctorcodeContoller();
  }

  SelectedApptData: DoctorAppointmentsByDoctorcodeContoller;
  AppointmentsListItemSelected(data: DoctorAppointmentsByDoctorcodeContoller) {
    //alert("appointment selected: " + data.PatientName);
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = true;
    this.SelectedApptData = data;
    this.LoadAppointmentDetailsByAppointmentCode(data.AppointmentCode);

  }
  LoadAppointmentDetailsByAppointmentCode(AppointmentCode: number) {
    var request: AppointmentDetailsByAppointmentCodeRequest = new AppointmentDetailsByAppointmentCodeRequest();
    request.ConditionalOperator = 10;
    request.AppointmentCode = AppointmentCode;
      request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      //this.pdata1 = this.SelectedAppointmentDetailsByAppointmentCodeController;
    this.GetAppointmentDetailsByAppointmentCodeContoller(request);

  }

  GetAppointmentDetailsByAppointmentCodeContoller(request: AppointmentDetailsByAppointmentCodeRequest) {
    // alert(this.SelectedDoctorData.ProviderCode);
    this.StartRefreshing();
    this.actorservice.GetAppointmentDetailsByAppointmentCodeContoller(request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
            this.SelectedAppointmentDetailsByAppointmentCodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          if (this.SelectedAppointmentDetailsByAppointmentCodeController.length > 0)
            this.SelectedAppointmentDetails = this.SelectedAppointmentDetailsByAppointmentCodeController[0];
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  GetDoctorAppointmentsByDoctorcodeContoller() {
    // alert(this.SelectedDoctorData.ProviderCode);
    this.StartRefreshing();
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.pdata = this.CurrentDoctorsListController;
      this.CurrentDoctorsListRequest.ConditionalOperator = 20;
      this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.pdata = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  constructor(private actorservice: ActorService,
    private loaderService: SpinnerService,
    private filter: DoctorListPipe,
    private filter1: PatientListPipe,
    private tosterservice: NGXToastrService,
    private parserFormatter: NgbDateParserFormatter
  ) {
    setInterval(() => {
      this.CurrentTime = new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()


    }, 1
    );
  }

  ngOnInit() {
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.LoadDoctorsList();
    this.CurrentSavePatientVisitInformationRequest = new SavePatientVisitRequest();

    this.CurrentSavePatientVisitInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }
  SelectedDoctorData: DoctorsListController;
  DoctorListItemSelected(doctor: DoctorsListController) {
    this.SelectedDoctorData = doctor;
    // alert(this.SelectedDoctorData.DisplayName);
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = false;

    // show selected doctor info..
    // if any speciffics are requried...
    // load doctor's appointments of today, default
    this.LoadDoctorAppointmentsByDoctor();
  }
  patientdatails() {
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = true;
  }

  toggle() {


    this.Checkin = true;
    //this.onSubmit();

  }
  toggle1() {
    this.Encstart = true;
    //this.onSubmit2();

  }
  toggle2() {
    this.Encend = true;
  }
  toggle3() {
    this.Checkout = true;
    }
    //addprop1(e) {
    //    if (e.target.checked) {
    //        this.onSubmit()
    //    }
    //    else  {
    //        this.onSubmitfalse();
    //    }
    //}
  onSubmit(statusText: string, e) {
      var statusVal = e.target.checked;

      //if (e.target.checked) {
      //    this.CurrentSavePatientVisitInformationRequest.ChekInTime = true;
      //}
      //else {
      //    this.CurrentSavePatientVisitInformationRequest.ChekInTime = null;
      //}
      this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 10;
      this.CurrentSavePatientVisitInformationRequest.ActionItem = statusText;
      this.CurrentSavePatientVisitInformationRequest.ActionEvent = statusVal;

      this.CurrentSavePatientVisitInformationRequest.ActorCode = this.SelectedAppointmentDetails.PatientCode;
     this.CurrentSavePatientVisitInformationRequest.ChekInTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentTime = this.SelectedAppointmentDetails.AppointmentTime;
    this.CurrentSavePatientVisitInformationRequest.CheckOutTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = new Date();
      this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = new Date();
      this.CurrentSavePatientVisitInformationRequest.VisitCode = this.SelectedAppointmentDetails.PatientVisit;
    this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = this.SelectedAppointmentDetails.ProviderSwapped;
    this.CurrentSavePatientVisitInformationRequest.ProviderCode = this.SelectedAppointmentDetails.ProviderCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = this.SelectedAppointmentDetails.AppointmentStatus;

    this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');


              this.LoadDoctorAppointmentsByDoctor();
              this.LoadAppointmentDetailsByAppointmentCode(this.SelectedAppointmentDetails.AppointmentCode);
              //this.GetAppointmentDetailsByAppointmentCodeContoller();


              this.stopRefreshing();
             
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

    }
  
  //  onSubmit2(d) {

  //      if (d.target.checked) {
  //          this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = true;
  //      }
  //      else {
  //          this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = null;
  //      }
  //  this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 20;

  //    this.CurrentSavePatientVisitInformationRequest.ActorCode = this.SelectedAppointmentDetails.PatientCode;
  //    this.CurrentSavePatientVisitInformationRequest.ChekInTime =null;
  //  this.CurrentSavePatientVisitInformationRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;
  //  this.CurrentSavePatientVisitInformationRequest.AppointmentTime = this.SelectedAppointmentDetails.AppointmentTime;
  //    this.CurrentSavePatientVisitInformationRequest.CheckOutTime = null;
  //    //this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = this.SelectedAppointmentDetails.EncounterStartTime.toString();
  //  this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = null;
  //  this.CurrentSavePatientVisitInformationRequest.VisitCode = this.SelectedAppointmentDetails.PatientVisit;
  //  this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = this.SelectedAppointmentDetails.ProviderSwapped;
  //  this.CurrentSavePatientVisitInformationRequest.ProviderCode = this.SelectedAppointmentDetails.ProviderCode;
  //  this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = this.SelectedAppointmentDetails.AppointmentStatus;

  //  this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {

  //          //alertFunctions.AlertParam('Saved Successfully.....!');
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');





  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");


  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



  //        }
  //        else {
  //          this.stopRefreshing();
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}
  //  onSubmitEncEnd(f) {

  //      if (f.target.checked) {
  //          this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = true;
  //      }
  //      else {
  //          this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = null;
  //      }
  //      this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 30;

  //      this.CurrentSavePatientVisitInformationRequest.ActorCode = this.SelectedAppointmentDetails.PatientCode;
  //      this.CurrentSavePatientVisitInformationRequest.ChekInTime = null;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentTime = this.SelectedAppointmentDetails.AppointmentTime;
  //      this.CurrentSavePatientVisitInformationRequest.CheckOutTime = null;
  //      this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = null;
  //      //this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = this.SelectedAppointmentDetails.EncounterEndTime.toString();
  //      this.CurrentSavePatientVisitInformationRequest.VisitCode = this.SelectedAppointmentDetails.PatientVisit;
  //      this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = this.SelectedAppointmentDetails.ProviderSwapped;
  //      this.CurrentSavePatientVisitInformationRequest.ProviderCode = this.SelectedAppointmentDetails.ProviderCode;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = this.SelectedAppointmentDetails.AppointmentStatus;

  //      this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
  //          .subscribe((result) => {
  //              this.ApiResData = result;
  //              if (!this.ApiResData.hasError) {

  //                  if (this.ApiResData.Result > 0) {

  //                      //alertFunctions.AlertParam('Saved Successfully.....!');
  //                      this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');





  //                      this.stopRefreshing();
  //                  }
  //                  else {
  //                      alertFunctions.AlertParam("Invalid Operation...!");


  //                      this.stopRefreshing();

  //                  }

  //              }
  //              else {
  //                  this.stopRefreshing();
  //                  if (this.ApiResData.ErrorData != "") {

  //                      alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



  //                  }
  //                  else {
  //                      this.stopRefreshing();
  //                      alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

  //                  }
  //              }

  //          },


  //              (error) => {

  //                  if (error == "401 - Unauthorized") {
  //                      alertFunctions.AlertParamEr(error);

  //                      this.stopRefreshing();



  //                  }
  //                  else {
  //                      alertFunctions.AlertParamEr(error);

  //                      this.stopRefreshing();
  //                  }
  //              }
  //          );

  //  }
  //  onSubmitCheckOut(g) {
  //      if (g.target.checked) {
  //          this.CurrentSavePatientVisitInformationRequest.CheckOutTime = true;
  //      }
  //      else {
  //          this.CurrentSavePatientVisitInformationRequest.CheckOutTime = null;
  //      }
  //      this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 40;

  //      this.CurrentSavePatientVisitInformationRequest.ActorCode = this.SelectedAppointmentDetails.PatientCode;
  //      this.CurrentSavePatientVisitInformationRequest.ChekInTime = null;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentTime = this.SelectedAppointmentDetails.AppointmentTime;
  //     // this.CurrentSavePatientVisitInformationRequest.CheckOutTime = ;
  //      this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = null;
  //      this.CurrentSavePatientVisitInformationRequest.EncounterEndTime =null;
  //      this.CurrentSavePatientVisitInformationRequest.VisitCode = this.SelectedAppointmentDetails.PatientVisit;
  //      this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = this.SelectedAppointmentDetails.ProviderSwapped;
  //      this.CurrentSavePatientVisitInformationRequest.ProviderCode = this.SelectedAppointmentDetails.ProviderCode;
  //      this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = this.SelectedAppointmentDetails.AppointmentStatus;

  //      this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
  //          .subscribe((result) => {
  //              this.ApiResData = result;
  //              if (!this.ApiResData.hasError) {

  //                  if (this.ApiResData.Result > 0) {

  //                      //alertFunctions.AlertParam('Saved Successfully.....!');
  //                      this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');





  //                      this.stopRefreshing();
  //                  }
  //                  else {
  //                      alertFunctions.AlertParam("Invalid Operation...!");


  //                      this.stopRefreshing();

  //                  }

  //              }
  //              else {
  //                  this.stopRefreshing();
  //                  if (this.ApiResData.ErrorData != "") {

  //                      alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



  //                  }
  //                  else {
  //                      this.stopRefreshing();
  //                      alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

  //                  }
  //              }

  //          },


  //              (error) => {

  //                  if (error == "401 - Unauthorized") {
  //                      alertFunctions.AlertParamEr(error);

  //                      this.stopRefreshing();



  //                  }
  //                  else {
  //                      alertFunctions.AlertParamEr(error);

  //                      this.stopRefreshing();
  //                  }
  //              }
  //          );

  //  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  pdata: any[];
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentDoctorsListController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentDoctorsListController, this.listFilter);
      }
    }
  }

  pdata1: any[];
  listFilter1: string;
  ngOnChanges1(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;

    this.criteriaChange1(this.listFilter1);
  }
  criteriaChange1(value: any) {
    if (this.filter1 != null) {
      if (value != '[object Event]') {
        this.listFilter1 = value;
        //alert(this.listFilter);
        this.pdata1 = this.filter1.transform(this.CurrentDoctorAppointmentsByDoctorcodeController, this.listFilter1);
      }
    }
  }
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  dateI: NgbDateStruct;
  TodayDate = new Date();
  Datediffer = new Date();
  DecrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
      var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
        monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
      this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
    this.RefreshPatientsByDate();
    //ind++;
  }
  IncrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
      var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
        monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
    this.RefreshPatientsByDate();
    //ind++;
  }
  dataChanged(newobj) {

    this.RefreshPatientsByDate();
  }

  RefreshPatientsByDate() {
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcodeContoller>();

    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCodeRequest();
    this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 10;
    //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorAppointmentsByDoctorcodeContoller();
    }
    //selectChanged(obj: any) {
       
    //    this.onSubmit();


    //}
    //selectChangedEnc(obj: any) {
    //    this.onSubmit2();
    //}
    //selectChangedEncEnd(obj: any) {
    //    this.onSubmitEncEnd();
    //}
    //selectChangedCheckOut(obj: any) {
    //    this.onSubmitCheckOut();
    //}
}
